import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { GENDER_PREFERENCES, PROVIDER_REGISTRATION_TITLE_PROPS } from "~/utils/providerRegistrationHelpers";
import BooleanRadioGroup from "./BooleanRadioGroup";

const WorkPreferences = () => {
  const { control } = useFormContext();

  return (
    <Stack direction="column" spacing={4}>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          Are you willing to work with minors (under 18 years old)?
        </Typography>
        <BooleanRadioGroup control={control} name="workPreferences.workWithMinors" />
      </Stack>
      <Stack direction="column" spacing={2}>
        <Typography align="left" {...PROVIDER_REGISTRATION_TITLE_PROPS}>
          What is your gender preference for your employer?
        </Typography>
        <Controller
          control={control}
          defaultValue={null}
          name="workPreferences.genderPreference"
          render={({ field }) => (
            <FormControl>
              <RadioGroup
                {...field}
                onChange={(e) => {
                  field.onChange(e.target.value);
                }}
              >
                {GENDER_PREFERENCES.map(([value, label]) => (
                  <FormControlLabel key={value} control={<Radio />} label={label} value={value} />
                ))}
              </RadioGroup>
            </FormControl>
          )}
        />
      </Stack>
    </Stack>
  );
};

export default WorkPreferences;
